export default __webpack_public_path__ + "static/media/glasses-of-wine.970720ec.jpg";